import { render, staticRenderFns } from "./TradeItemTable.vue?vue&type=template&id=1a7e31ed&"
import script from "./TradeItemTable.vue?vue&type=script&lang=js&"
export * from "./TradeItemTable.vue?vue&type=script&lang=js&"
import style0 from "./TradeItemTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports